<template>
  <div class="resource-item">
    <div class="item-content">
      <div :class="`type-icon ${typeMap[data.paper.formatType]}`" />
      <div class="title text-overflow-ellipsis ">
        {{ data.title }}
      </div>
    </div>
    <div class="btn-wrap">
      <template v-if="type===13">
        <div class="button button-small button-tight" @click="getResource(data.paper.id,'Paper')">
          <i class="iconfont icon-download-solid" />   Paper
        </div>
        <div class="button button-small button-tight" @click="getResource(data.answers.id,'Answers')">
          <i class="iconfont icon-download-solid" />     Answers
        </div>
      </template>
      <template v-if="type===14">
        <div class="button button-small button-tight" @click="getResource(data.paper.id,'Download')">
          <i class="iconfont icon-download-solid" />    Download
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { oneApi } from 'config/api'

import bus from 'common/bus';

import { s3Download } from 'common/utils.js';

export default {
  props: {
    data: {
      default: () => {},
      type: Object,
    },
    saData: {
      default: () => {},
      type: Object,
    },
    type: {
      default: 0,
      type: Number,
    },
  },
  data() {
    const studentId = this.$route.query.studentId || '';
    return {
      studentId,
      typeMap: {
        1: 'pdf',
        2: 'word',
        3: 'excel',
        4: 'mp4',
      },
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
  },
  methods: {

    async getResource(id, name) {
      console.log('PC邮箱8')
      if (!this.isLogin) {
        bus.$emit('login');
        return
      }
      const info = await this.$axios.post(oneApi.queryUserBasicInfo, { fillInAttention: true }, { rewritePostBody: true, uid: this.studentId })
      if (!info.data.email) {
        this.$store.dispatch('bindDialog/setDialogData', {
          visible: true,
          type: 'email',
        })
        return
      }
      if (!info.data.phone) {
        this.$store.dispatch('bindDialog/setDialogData', {
          visible: true,
          type: 'phone',
        })
        return
      }
      const res = await this.$axios.post(oneApi.getUrl, id, { rewritePostBody: true });
      if (Number(res.code) !== 0) {
        this.$ElMessage.error(res.msg);
        return
      }
      const resData = res.data || {}
      s3Download(resData.signedUrl)
      const data = { ...this.saData, button_name: name }
      this.Sensors.track('resources_card_click', data)
    },
  },
}
</script>
<style lang="scss" scoped>
.resource-item {
  background: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 14px 2px 2px;
  margin-bottom: 10px;

  .item-content {
    display: flex;
    align-items: center;

    .type-icon {
      width: 56px;
      height: 56px;
      background: #fff5f4;
      border-radius: 8px;
      overflow: hidden;
      margin-right: 8px;

      &.pdf {
        background: #fff5f4  url("~assets/images/resources/icon_pdf.png") no-repeat;
        background-size: 34px 40px;
        background-position: center;
      }

      &.word {
        background: #f3f7ff url("~assets/images/resources/icon_word.png") no-repeat;
        background-size: 34px 40px;
        background-position: center;
      }

      &.excel {
        background: #f0fcf8 url("~assets/images/resources/icon_excel.png") no-repeat;
        background-size: 34px 40px;
        background-position: center;
      }

      &.mp4 {
        background: #fff9ec url("~assets/images/resources/icon_mp4.png") no-repeat;
        background-size: 34px 40px;
        background-position: center;
      }
    }

    .title {
      width: 460px;
      font-size: 18px;
      font-weight: 500;
      color: var(--txt-color-lv3);
      line-height: 24px;
    }
  }

  .btn-wrap {
    display: flex;

    .button {
      padding: 7px 15px 6px 8px;
      margin-right: 10px;
      font-size: 14px;
      i { font-size: 20px; }

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }
  }

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
}
</style>
